interface StaffAssignee {
  person?: {
    first?: string | null;
    last?: string | null;
  } | null;
  email: string;
}

/**
 * Formats staff assignee name for display
 * Returns "First Last, email" if person data exists, otherwise just email
 */
export function getStaffAssigneeName(
  staffAssignee: StaffAssignee | null | undefined
): string {
  if (!staffAssignee) {
    return "No assignee";
  }

  if (staffAssignee.person) {
    const name = `${staffAssignee.person.first || ""} ${
      staffAssignee.person.last || ""
    }`.trim();
    if (name && staffAssignee.email) {
      return `${name}, ${staffAssignee.email}`;
    }
    if (name) {
      return name;
    }
  }

  return staffAssignee.email;
}
